export const loadPdfFlipbookReaderModule = () =>
  import('./PdfFlipbookReader').then((module) => ({
    default: module.PdfFlipbookReader,
  }))

export function preloadPdfFlipbookReader() {
  void loadPdfFlipbookReaderModule()
}
